import React, { useState } from "react";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap_white.css";
import CommonUtil from "../../../common";
import classes from "./CheckDetails.module.css";
import constants from "../../../../../globalization";
import printIcon from "../../../../../assets/images/Fireboard/print.png";
import fireIcon from "../../../../../assets/images/Fireboard/fireItems.png";
import FireboardUtils from "../../../../../util/fireboard-util";

import FireboardTip from "./FireboardTip";
import CheckItems from "./CheckItems";
import classNames from "classnames";
import paymentFailure from '../../../../../assets/images/TMS/paymentFailed.png';
import mapPinIcon from '../../../../../assets/images/Fireboard/action_buttons/mappin_white.png';
import Button from '../../../../../components/Button';
import ageVerifiedImg from '../../../../../assets/images/Fireboard/ageVerified.png';
import ageNotVerifiedImg from '../../../../../assets/images/Fireboard/ageNotVerified.png';
import ageRestrictedImg from '../../../../../assets/images/Fireboard/ageRestricted.png';

const printOptions = [
  {
    id: 0,
    display: "INDIVIDUAL ITEM LABELS",
  },
  {
    id: 1,
    display: "ORDER + ITEMS LABELS",
  },
  {
    id: 2,
    display: "FULL ORDER LABEL",
  },
  {
    id: 3,
    display: 'KITCHEN TICKET',
  },
  {
    id: 4,
    display: 'GUEST RECEIPT',
  },
];

const CheckDetails = (props) => {
  const {
    selectedItem = {},
    items = [],
    supportsTipsOnTotalAmount = false,
    showMemberDetailPopup = () => { },
    onPrintPress = () => { },
    pendingItems = [],
    getManagerNotifications: relatedNotifications,
    acknowledgeIdCheck,
    showApprovalReasonsPopup,
    checkDetailsStyles = {},
    currency,
    iso2,
    suppressTipsOnFireBoard,
    isLayoutView = false,
    enableGpsLocation,
    latitude,
    longitude,
    viewGuestLocationOnMap,
    onRequestRefreshGuestGPS,
    onClickSms,
    openCaptureSeatNamePopup,
    sendPendingItems,
    orderPendingItems,
    enableAgeRestrictedOrderingForSeat,
    onUpdateAgeRestrictedItemsForSeat,
    enableAgeRestrictedOrderingForCheck,
    enableAgeVerification,
  } = props || {};

  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [selectedAction, setSelectedAction] = useState(-1);

  const isPOSOrder =
    CommonUtil.getOrderTypeFromSourceType(selectedItem.sourceType) ===
    constants.orderType_POS;

  const renderOverlayContent = () => {
    return (
      <div className={classes.overlayContainer}>
        {printOptions.map((p, printIndex) => {
          return (
            <button
              key={p.id}
              className={classNames({ [classes.printBtn]: true, [classes.highligthtedAction]: selectedAction === printIndex })}
              onClick={() => {
                setTooltipVisible(false);
                onPrintPress("check", p);
              }}
              onMouseEnter={() => setSelectedAction(printIndex)}
              onMouseLeave={() => setSelectedAction(-1)}
            >
              <span className={classes.printBtnTextStyle}>{p.display}</span>
            </button>
          );
        })}
      </div>
    );
  };

  const getFormattedTime = field => {
    if (selectedItem.selectedCheckDetails && selectedItem.selectedCheckDetails[field]) {
      return FireboardUtils.getTimeInHrsMins(selectedItem.selectedCheckDetails[field]);
    }
    return '';
  };

  const getIsCurbOrder = () => {
    return selectedItem.sourceType === 5;
  };

  const getOrderStatus = (item) => {
    const orderStatusId = item.orderStatusId;
    switch (orderStatusId) {
      case 1:
        return constants.orderPending;
      case 2:
        return constants.orderReady;
      case 5:
        return constants.orderComplete;
      case 8:
        return constants.cancelOrderText;
      case 9:
        return constants.orderError;
      default:
        return "";
    }
  };

  const pendingItemsToBeShown = isPOSOrder ? Object.keys(pendingItems) : pendingItems;

  const order0 = (selectedItem.orders && selectedItem.orders.length > 0 && selectedItem.orders[0]) || {};

  let phoneNumberField = constants.phnNumberText,
    checkInNoteField = constants.checkInNote,
    tableField = constants.tableField,
    deliverToField = constants.deliveryToField;
  const { sourceType } = selectedItem || {};
  if (selectedItem && Object.keys(selectedItem).length > 0) {
    const { phoneNumber, selectedCheckDetails, stationNumber, deliverTo } = selectedItem || {};
    if (sourceType === 0) {
      tableField += stationNumber ? stationNumber : '';
      deliverToField += deliverTo ? deliverTo : '';
    } else {
      const { checkInNote } = selectedCheckDetails || {};
      phoneNumberField += phoneNumber ? `${FireboardUtils.formattedPhoneNumber(selectedItem.phoneNumber, iso2)}` : '';
      checkInNoteField += checkInNote ? checkInNote : '';
    }
  }

  const vendorName = order0?.marketplace
    ? order0?.marketplaceVendorName
      ? order0?.marketplaceVendorName
      : ''
    : order0?.deliveryVendorName
      ? order0?.deliveryVendorName
      : '';

  const isOneDineIntVendor = vendorName === 'OneDineInt';

  const vendorOrderId = order0?.marketplace
    ? order0?.marketplaceOrderId
      ? order0?.marketplaceOrderId
      : ''
    : order0?.deliveryVendorOrderId
      ? order0?.deliveryVendorOrderId
      : '';

  const orderNote = order0?.checkInNote && order0?.orderNote ? order0?.checkInNote + ' | ' + order0?.orderNote : order0?.checkInNote || order0?.orderNote || '';

  const orderMessage = order0?.message || '';
  const { slotName, locationUpdateElapsedTime, locationRefreshButtonColor } = selectedItem || {};

  let showLocation = FireboardUtils.isViewOnMapOptionVisible(enableGpsLocation, latitude, longitude, selectedItem.orders);

  const handleRequestRefresh = () => {
    onRequestRefreshGuestGPS && onRequestRefreshGuestGPS();
  };

  const showMap = () => {
    viewGuestLocationOnMap && viewGuestLocationOnMap();
  };

  const firePendingItems = () => {
    sendPendingItems && sendPendingItems();
  }

  let employeeName = `${selectedItem?.employeeFirstName ? selectedItem.employeeFirstName : ''} ${selectedItem?.employeeLastName ? selectedItem.employeeLastName : ''}`;
  employeeName = employeeName.trim();

  const disableAgeRestricted = order0?.disableAgeRestricted;
  const ageVerificationIcon = order0?.ageVerificationStatus === 5
    ? ageVerifiedImg
    : order0?.ageVerificationStatus === 1
      ? ageNotVerifiedImg
      : null;

  return (
    <div className={[classes.checkDetails, checkDetailsStyles].join(' ')}>
      <div className={classes.topContainer}>
        <div className={classes.phoneNumber}>
          <span className={classes.phoneNumberText}>{sourceType === 0 ? tableField : phoneNumberField}</span>
        </div>
        <div className={classes.checkIn}>
          <span className={classes.checkInText}>{sourceType === 0 ? deliverToField : checkInNoteField}</span>
          {slotName && <span className={classes.checkInText}>{constants.cubbyCaps}#: {slotName}</span>}
        </div>
        <div className={classes.printImageContainer}>
          {orderPendingItems && Object.keys(orderPendingItems) && Object.keys(orderPendingItems).length > 0 ? <button className={classes.printAllBtn} onClick={firePendingItems}>
            <img src={fireIcon} className={classes.iconSize} alt="print" />
          </button> : null}
          <Tooltip
            placement="bottomRight"
            visible={tooltipVisible}
            overlay={renderOverlayContent()}
            trigger={"click"}
            overlayInnerStyle={{ padding: "0.93vh", backgroundColor: "gray" }}
            onVisibleChange={(visible) => setTooltipVisible(visible)}
          >
            <button className={classes.printAllBtn}>
              <img src={printIcon} className={classes.iconSize} alt="print" />
            </button>
          </Tooltip>
        </div>
      </div>

      {employeeName && (
        <div className={classes.addressText}>
          <span className={classes.toolTipHeaderText}>{constants.empLabel}: {employeeName}</span>
        </div>
      )}

      <div className={classes.topContainer}>
        <div className={classes.phoneNumber}>
          <span className={classes.toolTipHeaderText}>{constants.checkOpen}</span>
          <span className={classes.toolTipHeaderText}>{getFormattedTime('orderDate')}</span>
        </div>
        <div className={classes.phoneNumber}>
          <span className={classes.toolTipHeaderText}>{constants.checkClosed}</span>
          <span className={classes.toolTipHeaderText}>{getFormattedTime('closeDate')}</span>
        </div>
        <div className={classes.itemCountContainer}>
          <span className={classes.toolTipHeaderText}>{constants.itemCount}:</span>
          <span className={classes.toolTipHeaderText}>{CommonUtil.getItemCount(selectedItem.items)}</span>
        </div>
        {getIsCurbOrder() && (
          <div className={classes.phoneNumber}>
            <span className={classes.toolTipHeaderText}>{constants.order}:</span>
            <span className={classes.toolTipHeaderText}>{getOrderStatus(selectedItem).toUpperCase()}</span>
          </div>
        )}
      </div>

      {selectedItem?.sourceType > 0 &&
        <div className={classes.topContainer}>
          {order0?.orderDate &&
            <div className={classes.pickUpText}>
              <span className={classes.toolTipHeaderText}>{constants.order.toUpperCase()}</span>
              <span className={classes.toolTipHeaderText}>
                {FireboardUtils.convertedDate(order0?.orderDate)} {FireboardUtils.getTimeInHrsMins(order0?.orderDate)}
              </span>
            </div>
          }
          {order0?.pickupDate &&
            <div className={classes.pickUpText}>
              <span className={classes.toolTipHeaderText}>{constants.pickUp}:</span>
              <span className={classes.toolTipHeaderText}>
                {FireboardUtils.convertedDate(order0?.pickupDate)} {FireboardUtils.getTimeInHrsMins(order0?.pickupDate)}
              </span>
            </div>
          }
        </div>
      }

      {orderNote && orderNote !== '' && (
        <div className={classes.addressText}>
          <span className={classes.toolTipHeaderText}>{constants.noteCaps}: {orderNote}</span>
        </div>
      )}

      {orderMessage && (
        <div className={classes.addressText}>
          <span className={classes.toolTipHeaderText}>{constants.messageLabel}: {orderMessage}</span>
        </div>
      )}

      {order0?.lastTextToPaySendDate && (
        <div className={classes.addressText}>
          <span className={classes.toolTipHeaderText}>{constants.textToPaySent.toUpperCase()}: {FireboardUtils.getTimeInHrsMins(order0?.lastTextToPaySendDate)}</span>
        </div>
      )}

      {order0?.lastTextToCheckInSendDate && (
        <div className={classes.addressText}>
          <span className={classes.toolTipHeaderText}>{constants.textToCheckInSent.toUpperCase()}: {FireboardUtils.getTimeInHrsMins(order0?.lastTextToCheckInSendDate)}</span>
        </div>
      )}

      {(enableAgeVerification || enableAgeRestrictedOrderingForCheck) && (
        <div className={classes.iconsWrapper}>
          {enableAgeVerification && ageVerificationIcon && (
            <img src={ageVerificationIcon} className={classes.ageRestricted} alt="age verification" />
          )}
          {enableAgeRestrictedOrderingForCheck && disableAgeRestricted && (
            <img src={ageRestrictedImg} className={classes.ageRestricted} alt="age restricted" />
          )}
        </div>
      )}

      {(order0 && !isOneDineIntVendor && Object.keys(order0).length > 0) ?
        <div className={classes.addressText}>
          <span className={classes.toolTipHeaderText} style={{ color: 'white' }}>{vendorOrderId !== '' ? vendorName + ' | ' + vendorOrderId + (order0.externalOrderNumber !== null ? ' | ' + order0.externalOrderNumber  : ''): vendorName}</span>
        </div>
        : null
      }

      {order0 && order0.delivery && (
        <div className={classes.addressText}>
          <span className={classes.toolTipHeaderText}>{`${order0.address || ''}, ${order0.city || ''} ${order0.state || ''} ${order0.zipCode || ''}`}</span>
        </div>
      )}

      {!FireboardUtils.isObjectBlank(selectedItem) && enableGpsLocation && (
        <div className={[classes.addressText, classes.locationView].join(' ')}>
          {showLocation && (
            <>
              <span className={classes.toolTipHeaderText}>{constants.locationUpdate}: {locationUpdateElapsedTime}</span>
              <Button className={classes.pinBtn} onClick={showMap}>
                <img src={mapPinIcon} className={classes.mapPin} alt="Pin" />
              </Button>
            </>
          )}
          <Button className={classes.reqRefreshBtn} onClick={handleRequestRefresh} style={{ backgroundColor: locationRefreshButtonColor }}>
            {constants.requestRefresh}
          </Button>
        </div>
      )}

      {pendingItemsToBeShown && pendingItemsToBeShown.length > 0 ? (
        <CheckItems
          posItemKeys={isPOSOrder && Object.keys(pendingItems).sort()}
          items={pendingItems}
          selectedItem={selectedItem}
          showMemberDetailPopup={showMemberDetailPopup}
          onPrintPress={onPrintPress}
          relatedNotifications={relatedNotifications}
          isPending={true}
          acknowledgeIdCheck={acknowledgeIdCheck}
          showApprovalReasonsPopup={showApprovalReasonsPopup}
          currency={currency}
          onClickSms={onClickSms}
          openCaptureSeatNamePopup={openCaptureSeatNamePopup}
          enableAgeRestrictedOrderingForSeat={enableAgeRestrictedOrderingForSeat}
          onUpdateAgeRestrictedItemsForSeat={onUpdateAgeRestrictedItemsForSeat}
        />
      ) : null}

      <CheckItems
        posItemKeys={isPOSOrder && Object.keys(items).sort()}
        items={items}
        selectedItem={selectedItem}
        showMemberDetailPopup={showMemberDetailPopup}
        onPrintPress={onPrintPress}
        relatedNotifications={relatedNotifications}
        acknowledgeIdCheck={acknowledgeIdCheck}
        showApprovalReasonsPopup={showApprovalReasonsPopup}
        currency={currency}
        onClickSms={onClickSms}
        openCaptureSeatNamePopup={openCaptureSeatNamePopup}
        enableAgeRestrictedOrderingForSeat={enableAgeRestrictedOrderingForSeat}
        onUpdateAgeRestrictedItemsForSeat={onUpdateAgeRestrictedItemsForSeat}
      />
      {isLayoutView && <CheckStatus check={selectedItem} />}
      <FireboardTip
        selectedItem={selectedItem}
        supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
        currency={currency}
        suppressTipsOnFireBoard={suppressTipsOnFireBoard}
      />
    </div>
  );
};

export default CheckDetails;

const CheckStatus = ({ check }) => {
  const { paidIcon, preAuthIcon, sourceType, tickets, orders, tab } = check || {};

  let delivery = false;
  let isMarketPlaceOrder = false;
  if (orders && orders.length > 0) {
    delivery = orders[0].delivery || false;
    isMarketPlaceOrder = orders[0].marketplace || false;
  }
  const modeSrc = FireboardUtils.getCheckSourceIcon(sourceType, delivery, isMarketPlaceOrder, tab);
  const errorTicket =
    Array.isArray(tickets)
    && tickets.length
    && tickets.some(t => t.paymentStatus && t.paymentStatus.toLowerCase() !== 'hidden' && t.enableRepostPos);

  const Status = ({ label, imgSrc }) => (
    <div className={classes.statusCol}>
      <span className={classes.statusTxt}>{label}</span>
      <img src={imgSrc} className={classes.statusImg} alt='' />
    </div>
  );

  return (
    <div className={classes.statusWrapper}>
      {modeSrc ? <Status imgSrc={modeSrc} label={constants.mode} /> : null}
      {paidIcon ? <Status imgSrc={paidIcon} label={constants.paid} /> : null}
      {preAuthIcon ? <Status imgSrc={preAuthIcon} label={constants.preauth} /> : null}
      {errorTicket ? <Status imgSrc={paymentFailure} label={constants.orderError} /> : null}
    </div>
  );
};